import React from 'react'
import { Box, Flex, Link } from 'rebass/styled-components'
import styled from 'styled-components'
import InstagramIcon from '../../assets/icons/instagram.svg'
import FacebookIcon from '../../assets/icons/facebook.svg'
import YoutubeIcon from '../../assets/icons/youtube.svg'

const SocialChannel = styled(Link)`
    background-color: ${(props) => props.theme.colors.aquaDark};
    border-color: ${(props) => props.theme.colors.aquaDark};
    border-radius: 100%;
    border-style: solid;
    border-width: 1px;
    display: block;
    height: 28px;
    outline: none;
    position: relative;
    width: 28px;

    &:after {
        background-color: transparent;
        border-color: ${(props) => props.theme.colors.aquaDark};
        border-radius: 100%;
        border-style: solid;
        border-width: 2px;
        content: '';
        display: block;
        height: 100%;
        left: -2px;
        position: absolute;
        top: -2px;
        transform: scale(1.0);
        transform-origin: 50% 50%;
        transition-delay: 0, 10ms;
        transition-duration: 325ms, 425ms;
        transition-property: transform, opacity;
        transition-timing-function: ease-out, linear;
        width: 100%;
        will-change: transform, opacity;
        z-index: 0;
    }

    &:hover:after {
        opacity: 0.0;
        transform: scale(1.35);
    }
`
const Social = ({ share = false }) => {
    const url = typeof window !== 'undefined' ? window.location.href : '';
    return (
        <Flex
            alignContent="center"
            alignItems="center"
        >
            <Box
                alignSelf="stretch"
                flexShrink="0"
                mr="sm"
                width="28px"
            >
                <SocialChannel target="_blank" href="https://www.instagram.com/kidstonmotorcars/">
                    <Flex alignItems='center' justifyContent='center' height="100%" width="100%">
                        <Box width="15px">
                            <InstagramIcon />
                        </Box>
                    </Flex>
                </SocialChannel>
            </Box>
            <Box
                alignSelf="stretch"
                flexShrink="0"
                mr="sm"
                width="28px"
            >
                <SocialChannel href={(share) ? `https://www.facebook.com/sharer/sharer.php?u=${url}` : 'https://facebook.com/Kidston-Motorcars-131382396919675/'}>
                    <Flex alignItems='center' justifyContent='center' height="100%" width="100%">
                        <Box width="10px">
                            <FacebookIcon />
                        </Box>
                    </Flex>
                </SocialChannel>
            </Box>
            <Box
                alignSelf="stretch"
                flexShrink="0"
                width="28px"
            >
                <SocialChannel target="_blank" href="https://www.youtube.com/channel/UCiuFwH2KXoX0iT1Va98AVxQ">
                    <Flex alignItems='center' justifyContent='center' height="100%" width="100%">
                        <Box width="15px">
                            <YoutubeIcon />
                        </Box>
                    </Flex>
                </SocialChannel>
            </Box>
        </Flex>
    )
}

export default Social
